import "./VehiclesEditFooter.scss";

import { useVehiclesEditForm } from "../../../../../hooks/useVehiclesEditForm";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const VehiclesEditFooter = ({id}) => {
    const { handleSend } = useVehiclesEditForm({id});

    return (
        <div className={"vehicles-edit-footer"}>
            <Button title={"Добавить"} onClick={handleSend}/>
        </div>
    )
}

export default VehiclesEditFooter;